import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
// Job component definition
const Job = ({ title, description }) => {
  // Truncate description if it's longer than 100 characters
  const truncatedTitle = title && title.length > 80 ? `${title.slice(0, 80)}...` : title;

  return (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {truncatedTitle}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );
};

Job.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

// Function to generate columns
const columns = [
  { Header: "Count", accessor: "counter", width: "10%" },
  { Header: "Type", accessor: "type", width: "10%" },
  { Header: "Text", accessor: "text", width: "45%" },
  { Header: "Regular Price", accessor: "regular_price", width: "10%" },
  { Header: "Deal Price", accessor: "deal_price", width: "10%" },
  { Header: "Discount", accessor: "discount", width: "10%" },
  { Header: "Sub ID", accessor: "sub_id", width: "10%" },
  { Header: "Link", accessor: "link", width: "10%" },
  { Header: "Currency", accessor: "currency", width: "10%" },
  { Header: "Status", accessor: "status", width: "10%" },
  { Header: "Category", accessor: "category", width: "10%" },
  { Header: "Channel", accessor: "channel", width: "10%" },
  { Header: "Id", accessor: "id", width: "5%" },
  { Header: "Action", accessor: "action", width: "10%" },
];

// Function to create rows from data
const createRowsFromData = (data, handleShow) => {
  return data.map((item) => ({
    counter: <Job title={item.counter} description="" />,
    type: <Job title={getMessageType(item.message_type)} description="" />,
    text: <Job title={item.text} description="" />,
    regular_price: (
      <MDTypography component="a" variant="button" color="text" fontWeight="medium">
        {item.regular_price}
      </MDTypography>
    ),
    deal_price: (
      <MDTypography component="a" variant="button" color="text" fontWeight="medium">
        {item.deal_price}
      </MDTypography>
    ),
    discount: (
      <MDTypography component="a" variant="button" color="text" fontWeight="medium">
        {item.discount}
      </MDTypography>
    ),
    sub_id: <Job title={item.sub_id ? item.sub_id.toString() : ""} description="" />,
    link: (
      <MDTypography
        component="a"
        href={item.link}
        target="_blank"
        variant="caption"
        color="text"
        fontWeight="medium"
      >
        {item.link}
      </MDTypography>
    ),
    currency: <Job title={item.currency} description="" />,
    status: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={item.state}
          color={getStatusColor(item.state)}
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    category: <Job title="" description={item.category_title} />,
    channel: <Job title="" description={item.channel_name} />,
    id: <Job title="" description={item.id} />,
    action: (
      <MDTypography
        component="a"
        href="#"
        variant="button"
        color="text"
        fontWeight="medium"
        onClick={() => handleShow(item)} // Call handleShow here
      >
        Edit
      </MDTypography>
    ),
  }));
};

// Function to determine status color
const statusColors = {
  posted: "success",
  failed: "error",
  pending: "info",
};

const messageType = {
  singleproduct: "Signle Product",
  multiple_products: "Multiple Products",
  categories: "Categories",
  custom_message: "Custom Message",
};

const getStatusColor = (status) => statusColors[status] || "default";
const getMessageType = (type) => messageType[type] || "default";

const authorsTableData = {
  columns,
  createRowsFromData,
};

export default authorsTableData;
